import manifestation from "../assets/images/manifestation.jpg"
import reclamation from "../assets/images/reclamation.png"
import revendication from "../assets/images/revendication.jpeg"
import tyranie from "../assets/images/tyranie.jpg"

export const articlesCategories = ["All", "Réclammation", "Sittin", "Marche", "Révolte"]

export const articleData = [
    {
        image: reclamation,
        auteur: "Akim Gentil",
        datePub: "22 Janv 2020",
        category: "Réclammation",
        titre: "Comment reclammer ses droits",
        description: "lorem ipsum sit dollar ectum filiider",
        link: "https://gloire-mutaliko.netlify.app/"
    },


    {
        image: manifestation,
        auteur: "Gloire Salva",
        datePub: "24 Juil 2022",
        category: "Sittin",
        titre: "Organiser un sittin et le reussir",
        description: "lorem ipsum sit dollar ectum filiider",
        link: "https://gloire-mutaliko.netlify.app/"
    },
    {
        image: manifestation,
        auteur: "Gloire Salva",
        datePub: "24 Juil 2022",
        category: "Sittin",
        titre: "Organiser un sittin et le reussir",
        description: "lorem ipsum sit dollar ectum filiider",
        link: "https://gloire-mutaliko.netlify.app/"
    },

    {
        image: revendication,
        auteur: "Hitler",
        datePub: "11 Mars 1886",
        category: "Révolte",
        titre: "De l'esprit de revendication",
        description: "lorem ipsum sit dollar ectum filiider",
        link: "https://gloire-mutaliko.netlify.app/"
    },

    {
        image: tyranie,
        auteur: "Martin Luther",
        datePub: "07 Dec 1763",
        category: "Révolte",
        titre: "Se liberer de la tyranie",
        description: "lorem ipsum sit dollar ectum filiider",
        link: "https://gloire-mutaliko.netlify.app/"
    },
    {
        image: tyranie,
        auteur: "Martin Luther",
        datePub: "07 Dec 1763",
        category: "Révolte",
        titre: "Se liberer de la tyranie",
        description: "lorem ipsum sit dollar ectum filiider",
        link: "https://gloire-mutaliko.netlify.app/"
    },
]

export const tagsData = [
    { tag: 'Blockchain' },
    { tag: 'Cardano' },
    { tag: 'Plutus' },
    { tag: 'Haskell' },
    { tag: 'Ekival' },
    { tag: 'Mobilize' },
    { tag: 'Stakepool' },
]